import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "イヤー 2",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"a\"><path d=\"M0 0h24v24H0z\" style=\"fill:none;stroke-width:0;\"></path></clipPath></defs><g data-name=\"グループ 18798\"><g data-name=\"グループ 18897\" style=\"clip-path:url(#a);\"><path d=\"M22.5 21.46c-.3.3-2.8 3.6-6.9 2.2-3.7-1.3-7-3.6-9.51-6.69-2.6-3.01-4.3-6.5-5-10.3-.7-4.19 3-6.09 3.4-6.39s1.9-.6 2.6.5c.9 1.6 1.6 3.2 2.1 4.9.1.8-.7 1.6-1.6 1.8s-.9.7-.9.7.5 1.9 3.6 5.4 4.8 4.4 4.8 4.4.5.1.8-.8 1.1-1.4 2.1-1.3c1.6.8 3.2 1.7 4.6 2.9.8.9.2 2.4-.1 2.7\" data-name=\"パス 11789\" style=\"stroke-width:0;fill:#c03;\"></path></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }